export class Empresa {
    id: number;
    nome: string;
    crt?: number | null;
  
    constructor(id: number, nome: string, crt?: number | null) {
      this.id = id;
      this.nome = nome;
      this.crt = crt || null;
    }
  }
  